import _extends from 'babel-runtime/helpers/extends';

import { language } from '@/common/storage';
import appicon from './appicon.vue';
var _defaultQuery = {
  name: '',
  project_id: '',
  orientation: '',
  promoted_type: '',
  platform: '',
  iosUrl: '',
  iosIcon: '',
  iosName: '',
  androidUrl: '',
  androidIcon: '',
  androidName: '',
  lang: '',
  account: ''
};
export default {
  props: ['data', 'visible'],
  components: {},
  data: function data() {
    return {
      model: _defaultQuery
    };
  },

  methods: {
    resetModel: function resetModel() {
      this.model = _defaultQuery;
    },
    initModel: function initModel() {
      this.model = _extends({}, this.model, this.data);
    }
  },
  watch: {
    visible: function visible(val) {
      if (val) {
        this.resetModel();
        this.initModel();
      }
    }
  },
  mounted: function mounted() {
    this.resetModel();
    this.initModel();
  },

  computed: {
    formConfig: function formConfig() {
      return {
        'label-width': language.get() === 'en' ? '170px' : '120px'
      };
    },
    schemaHd: function schemaHd() {
      return {
        type: 'object',
        properties: {
          name: {
            title: this.$t('playTurbo.playableProject.playable.filter.projectname'),
            component: 'plain-text'
          },
          project_id: {
            title: this.$t('playTurbo.playableProject.playable.filter.projectid'),
            component: 'plain-text'
          },
          orientation: {
            visible: !!this.model.orientation,
            title: this.$t('playTurbo.commonTemplate.creativeInfo.form.direction.label'),
            component: 'plain-text'
          }
        }
      };
    },
    schemaBd: function schemaBd() {
      return {
        type: 'object',
        properties: {
          promoted_type: {
            title: this.$t('playTurbo.commonTemplate.creativeInfo.form.promotedType.label'),
            component: 'plain-text'
          },
          platform: {
            title: this.$t('playTurbo.commonTemplate.creativeInfo.form.platform.label'),
            component: 'plain-text'
          },
          iosUrl: {
            visible: !!this.model.iosUrl,
            title: this.$t('playTurbo.commonTemplate.creativeInfo.form.iOSURL.label'),
            component: 'plain-text'
          },
          iosIcon: {
            visible: !!this.model.iosUrl,
            title: this.$t('playTurbo.commonTemplate.creativeInfo.form.appIcon.label'),
            component: appicon
          },
          iosName: {
            visible: !!this.model.iosUrl,
            title: this.$t('playTurbo.commonTemplate.creativeInfo.form.appName.label'),
            component: 'plain-text'
          },
          androidUrl: {
            visible: !!this.model.androidUrl,
            title: this.$t('playTurbo.commonTemplate.creativeInfo.form.androidURL.label'),
            component: 'plain-text'
          },
          androidIcon: {
            visible: !!this.model.androidUrl,
            title: this.$t('playTurbo.commonTemplate.creativeInfo.form.appIcon.label'),
            component: appicon
          },
          androidName: {
            visible: !!this.model.androidUrl,
            title: this.$t('playTurbo.commonTemplate.creativeInfo.form.appName.label'),
            component: 'plain-text'
          }
        }
      };
    },
    schemaFt: function schemaFt() {
      return {
        type: 'object',
        properties: {
          lang: {
            title: this.$t('playTurbo.common.pushdownloadRecordDialog.infoDialog.lang'),
            component: 'plain-text'
          },
          account: {
            visible: !!this.model.account,
            title: this.$t('playTurbo.common.pushdownloadRecordDialog.infoDialog.account'),
            component: 'plain-text'
          }
        }
      };
    }
  }
};